export type { QuizContentProps } from "./QuizContent";
export { QuizContent } from "./QuizContent";
